import { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
    setExpiredScheduler,
    setLoadingReply,
} from "../../features/messagesSlice.js";
import useSendData from "../../hooks/useSendData.js";
import useRefreshData from "../../hooks/useRefreshData.js";
import SendMessageButton from "../atoms/buttons/SendMessageButton.jsx";
import TextInput from "../atoms/texts/TextInput.jsx";
import MessageLimit from "../atoms/texts/MessageLimit.jsx";

export default function SendMessage() {
    const dispatch = useDispatch();
    const textBoxContainer = useRef(null);
    const expiredAt = useSelector((state) => state.messages.expiredAt);
    const loadingReply = useSelector((state) => state.messages.loadingReply);
    const expiredScheduler = useSelector(
        (state) => state.messages.expiredScheduler
    );
    const isEnd = useSelector((state) => state.messages.isEnd);
    const messages = useSelector((state) => state.messages.messages);
    const messageLimit = useSelector((state) => state.messages.messageLimit);

    const { sendMessage } = useSendData();
    const { handleExpirySchedule } = useRefreshData();

    useEffect(() => {
        if (expiredScheduler) clearInterval(expiredScheduler);
        if (expiredAt && !isEnd) {
            const scheduler = setInterval(() => {
                handleExpirySchedule();
            }, 30000);
            dispatch(setExpiredScheduler(scheduler));
        } else if (isEnd) {
            clearInterval(expiredScheduler);
        }
    }, [expiredAt, isEnd, messages]);

    const sendNewMessage = async (textBoxContainer) => {
        if (!loadingReply) {
            dispatch(setLoadingReply(true));
            const containerElement = textBoxContainer.current;
            let userInput = containerElement.innerHTML
                .replace(/<div>|<br.*?>/gi, "\n")
                .replace(/<\/div>/g, "")
                .replace(/&nbsp;/g, " ")
                .replace(/&amp;/g, "&")
                .replace(/&lt;/g, "<")
                .replace(/&gt;/g, ">")
                .replace(/&quot;/g, '"')
                .replace(/&apos;/g, "'")
                .replace(/\n/g, "<br>")
                .trim();

            // Mask user input
            userInput = userInput.replace(
                /(\d[\s|\-|\\|/|_|,]?){10,}/g,
                (match) => match.replace(/\d/g, "*")
            );

            containerElement.textContent = "";
            containerElement.focus();

            await sendMessage(userInput);
        }
    };

    return (
        <div className="send-message">
            {!isEnd && (
                <>
                    <div className="text-input">
                        <TextInput
                            sendNewMessage={sendNewMessage}
                            textBoxContainer={textBoxContainer}
                        />
                        <div className="send-button">
                            <SendMessageButton
                                sendNewMessage={() =>
                                    sendNewMessage(textBoxContainer)
                                }
                            />
                        </div>
                    </div>
                </>
            )}
            {messageLimit && <MessageLimit />}
        </div>
    );
}
